import {ILocation} from "@game/game";

export interface ILetter {
    letter: string,
    placed?: number
    player?: string
}
export class Letter {
    _regionId?: number;
    _tileId?: number;

    constructor(private props: ILetter) {}

    get letter() {
        return this.props.letter;
    }

    get placed() {
        return this.props.placed;
    }

    get player() {
        return this.props.player ?? null;
    }

    get regionId() {
        return this._regionId;
    }

    get tileId() {
        return this._tileId;
    }
    get user() {
        return this.props.player ?? null;
    }

    getLocation() {
        return {
            regionId: this._regionId,
            tileId: this._tileId
        } as ILocation
    }

    getIsPlaced() {
        return this._regionId !== undefined && this._tileId !== undefined;
    }

    placeOnMap(regionId: number, tileId: number) {
        this._regionId = regionId;
        this._tileId = tileId;
    }
    
    removeFromMap() {
        this._regionId = undefined;
        this._tileId = undefined;
    }
}